import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-upload-trigger',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './upload-trigger.component.html'
})
export class UploadTriggerComponent {
  @Input() accept = 'application/pdf';
  @Output() fileSelected = new EventEmitter<File>();
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;

  openPicker() {
    this.fileInput?.nativeElement?.click();
  }

  onFileChange(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input?.files?.length) return;
    this.fileSelected.emit(input.files[0]);
    input.value = '';
  }
}
